import React from 'react';
import { LogoContainer, LogoContainerProps } from './MightyLogoLink.styles';
import MightyProLogo from 'src/images/2023_Q4/MightyProLogo';
import AnimatedMightyLogo from '../AnimatedMightyLogo/AnimatedMightyLogo';

export type MightyHeaderLogoType = 'standard' | 'pro' | 'hidden';

interface MightyHeaderLogoProps extends LogoContainerProps {
  logoType: MightyHeaderLogoType;
  to: string;
  forceScale?: boolean;
  className?: string;
}

const MightyHeaderLogo = ({ logoType, ...props }: MightyHeaderLogoProps): JSX.Element => {
  if (logoType === 'hidden') {
    return null;
  }

  return <LogoContainer {...props}>{logoType === 'pro' ? <MightyProLogo /> : <AnimatedMightyLogo />}</LogoContainer>;
};

export default MightyHeaderLogo;
